import React from 'react'

import { Button, Icon, type IconStringList } from '../../module'
import styles from './_empty-state.module.scss'
import { type ButtonProps } from '../Button/Button.models'

export type EmptyStateProps = {
  /** Text to display in bold. */
  primaryText: string
  /** Optional secondary text beneath `primaryText`. */
  secondaryText?: string
  /** Optional icon to display at the top. */
  icon?: IconStringList
  /** Optional button to display at bottom. */
  buttonProps?: ButtonProps
  /** Optional prop to add a test id to the EmptyState for QA testing */
  qaTestId?: string
}

const EmptyState = ({
  primaryText,
  secondaryText,
  icon,
  buttonProps,
  qaTestId = 'empty-state',
}: EmptyStateProps): React.JSX.Element => {
  return (
    <div
      className={styles.widthFull}
      data-testid='empty-state-component'
      qa-test-id={qaTestId}
    >
      <div className={styles.content}>
        {icon && <Icon icon={icon} iconSize='48px' />}
        <div
          className={styles.primaryText}
          data-testid='empty-state-primary-text'
        >
          {primaryText}
        </div>
        {secondaryText && (
          <div
            className={styles.secondaryText}
            data-testid='empty-state-secondary-text'
          >
            {secondaryText}
          </div>
        )}
        {buttonProps ? (
          <Button styleType={'primary-blue'} {...buttonProps} />
        ) : null}
      </div>
    </div>
  )
}

export default EmptyState
